import VideoPostback from './VideoPostback';
export default VideoPostback;
